import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDashedLine = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 18a2 2 0 1 0 0 4h3a2 2 0 1 0 0-4H5Zm9 0a2 2 0 1 0 0 4h3a2 2 0 1 0 0-4h-3Zm7 2a2 2 0 0 1 2-2h3a2 2 0 1 1 0 4h-3a2 2 0 0 1-2-2Zm11-2a2 2 0 1 0 0 4h3a2 2 0 1 0 0-4h-3Z"
	})
});
export default SvgDashedLine;
